export const setFlex = ({ justify, align, direction }) => {
  let style = `
      display: flex;
      ${justify && `justify-content: ${justify}`};
      ${align && `align-items: ${align}`};
      ${direction && `flex-direction: ${direction}`};
    `;
  return style;
};

export const setPosition = ({ position, top, bottom, left, right, zIndex }) => {
  let style = `
      ${position && `position: ${position}`};
      ${top && `top: ${top}px`};
      ${bottom && `bottom: ${bottom}px`};
      ${left && `left: ${left}px`};
      ${right && `right: ${right}px`};
      ${zIndex && `z-index: ${zIndex}`};
    `;
  return style;
};
